import React from 'react'
import PropTypes from 'prop-types'
import { SessionStore } from '../../stores/session'
import { PrettySwitch } from '../pretty-switch'
import { inject, observer } from 'mobx-react'
import { publish } from '../../utils/pubsub'
import _ from 'lodash'
import { trimmedSpaces } from './../../../ui/services/trimmedSpaces'
import { FormGroup, Input } from 'reactstrap'

@inject('sessionStore')
@observer
class CompanyModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      valid: false,
      name: '',
      sourceReference: '',
      numberImportParts: 1,
      isCompanyActive: false,

      importParts: [
        {
          importPart: '',
          type: 'basic',
          active: false
        }
      ],
      numberGLElements: 0,
      GLElements: [
        {
          glNumber: 1,
          label: '',
          numberCharacters: 1
        }
      ]
    }
    this.save = this.save.bind(this)
    this.companyNameRef = React.createRef()
    this.importCountChangeRef = React.createRef()
    this.importCompanyRef = React.createRef()
    this.parentDropdown = React.createRef()
    this.statusToggleRef = React.createRef()
    this.importToggleRef = React.createRef()
    this.importPartRef = React.createRef()
  }

  handleSubmit = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const finalFieldValue = this.checkData()
    const arrToStr = finalFieldValue.join(',')
    if (arrToStr) {
      publish('toastr.danger', 'GL elements should be unique ')
      this.setState({
        valid: true
      })
    } else {
      this.props.companyModalRef.current.close()
      this.setState({
        valid: true
      }, () => {
        this.save()
      })
    }
  }

  handleErrorSubmit = (e, formData, errorInputs) => {
    e.preventDefault()
    e.stopPropagation()
    console.error(errorInputs)
  }

  save () {
    const takeName = trimmedSpaces(this.state.name)
    const takeSourceReference = trimmedSpaces(this.state.sourceReference)
    const takeimport = this.state.importParts.map(item => {
      item.importPart = trimmedSpaces(item.importPart)
      return item
    })
    let glElements = this.state.GLElements.map(item => {
      item.label = trimmedSpaces(item.label)
      return item
    })
    // if number of GL elements set as 0 then the GL element array should be empty
    if (this.state.numberGLElements === 0) {
      glElements = []
    }
    if (this.state.isCompanyActive !== true) {
      this.setState({
        isCompanyActive: false
      })
    }
    if (this.state.valid) {
      this.setState({ name: takeName, sourceReference: takeSourceReference, importParts: takeimport, GLElements: glElements }, () => {
        this.props.saveFunction(this.state.name, this.state.sourceReference, this.state.isCompanyActive,
          this.state.numberImportParts, this.state.numberGLElements, this.state.importParts, this.state.GLElements)
      })
    }
  }

  UpdateData (e, element) {
    const updateData = [...this.state.GLElements]
    const index = e.target.name.match(/(\d+)/)[0]
    switch (element) {
      case 1:
        updateData[index - 1].label = e.target.value
        break
      case 2:
        updateData[index - 1].numberCharacters = parseInt(e.target.value)
        break
    }
    this.setState({
      GLElements: updateData
    })
  }

  handleOpened = () => {
    const GLElementsDisplayContent = []
    const GLElements = this.props.glElements
    const maxLengthGlElements = []

    for (let i = 0; i < GLElements.length; i++) {
      maxLengthGlElements.push(GLElements[i].glNumber)
    }
    const GLElementsLength = Math.max(...maxLengthGlElements)

    if (GLElements.length >= 1 && this.props.glElements[0].label !== '') {
      for (let i = 0; i < GLElementsLength; i++) {
        const tempGLElement = {
          glnumber: (i + 1),
          label: '',
          numberCharacters: 1
        }
        GLElementsDisplayContent.push(tempGLElement)
      }

      for (let i = 0; i < GLElements.length; i++) {
        const pos = (GLElements[i].glNumber) - 1
        GLElementsDisplayContent[pos] = GLElements[i]
      }
    }
    this.setState({
      name: this.props.name,
      sourceReference: this.props.sourceReference,
      isCompanyActive: (this.props.isCompanyActive === undefined) ? false : this.props.isCompanyActive,
      hasJournal: (this.props.hasJournal === undefined) ? false : this.props.hasJournal,
      numberImportParts: this.props.numberImportParts,
      numberGLElements: (this.props.Action === 'add' || this.props.glElements[0].label === '') ? '' : this.props.numberGLElements,
      importParts: this.props.ImportParts.slice().sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)), // to handle rearangement of import parts list inside the modal
      GLElements: GLElementsDisplayContent,
      htmlContents: null
    }, () => {
      this.setup()
    })
  }

  checkData () {
    let importCount = 0
    let glElementsCount = 0
    const importParts = [...this.state.importParts]
    importParts.forEach(data => {
      data.importPart = trimmedSpaces(data.importPart)
      importCount++
    })
    const distintGlValues = []
    const sameGlValues = []

    const GLElements = [...this.state.GLElements]
    GLElements.forEach((item, loc) => {
      item.label = trimmedSpaces(item.label)
      const glArr = _.findIndex(distintGlValues, i => {
        return i.label === item.label
      })
      if (glArr <= -1) {
        distintGlValues.push(item)
      } else {
        sameGlValues.push(loc)
      }
    })

    GLElements.forEach((data, index) => {
      glElementsCount++
      data.glNumber = index + 1
    })

    if (importCount > 0) {
      importParts.splice(importCount)
      GLElements.splice(glElementsCount)
    }

    this.setState({
      importParts,
      GLElements,
      numberImportParts: importCount,
      numberGLElements: (glElementsCount === 0) ? '' : glElementsCount
    })
    return sameGlValues
  }

  updateGlElements (selectedCount) {
    let count = null
    if (selectedCount > this.state.GLElements.length) {
      count = selectedCount - this.state.GLElements.length
      for (let i = 0; i < count; i++) {
        this.state.GLElements.push({
          glNumber: '',
          label: '',
          numberCharacters: 1
        })
      }
    } else {
      this.state.GLElements.splice(selectedCount)
    }
  }

  updateImportParts (selectedCount) {
    const importParts = [...this.state.importParts]
    let count = null
    if (selectedCount > this.state.importParts.length) {
      count = selectedCount - this.state.importParts.length
      for (let i = 0; i < count; i++) {
        importParts.push({
          importPart: '',
          type: 'basic',
          active: false
        })
      }
    } else {
      importParts.splice(selectedCount)
    }
    this.setState({ importParts }, () => this.handleSelects())
  }

  handleClose =(e) => {
    this.companyNameRef.current.required = false
    this.importCompanyRef.current.required = false
    this.handleImportPart(false)
  }

  componentDidMount () {
    this.setState({
      valid: false
    }, () => {
      this.setup()
      this.props.companyModalRef.current.addEventListener('submit', (e) => this.handleSubmit(e))
      this.props.companyModalRef.current.addEventListener('close', (e) => this.handleClose(e))
    })
  }

  handleActiveImportChange = (e, index) => {
    const importParts = [...this.state.importParts]
    importParts[index].active = e.target.checked
    this.setState({ importParts })
  }

  handleImportPart = (bool) => {
    const getImportComponent = document.getElementsByTagName('mosaic-text-input')
    Array.from(getImportComponent).forEach(item => {
      if (item.id === 'importPartElement') {
        item.required = bool
      }
    })
  }

  setup = () => {
    this.textInputBindings()
    this.companyActiveToggle()
    this.handleSelects()
    this.companyNameRef.current.required = true
    this.importCompanyRef.current.required = true
    this.handleImportPart(true)
    this.importCountChangeRef.current.value = this.state.numberImportParts
    this.parentDropdown.current.value = this.state.numberGLElements
    this.statusToggleRef.current.checked = this.state.isCompanyActive
    this.statusToggleRef.current.label = this.state.isCompanyActive ? 'Yes' : 'No'
    this.importCountChangeRef.current.addEventListener('change', (e) => this.handleChange(e))
    this.parentDropdown.current.addEventListener('change', (e) => this.GLElementCountChange(e))
    this.props.companyModalRef.current.addEventListener('show', () => this.handleOpened())
  }

  handleSelects = () => {
    const elements = document.getElementsByTagName('mosaic-select-input')
    for (const i of elements) {
      if (i.name && i.name.includes('numberOfCharacters')) {
        i.addEventListener('change', (e) => {
          this.UpdateData(e, 2)
        })
      } else if (i.name && i.name.includes('selectType')) {
        i.addEventListener('change', (e) => this.updateImport(e, e.target.name))
      }
    }
    const textElements = document.getElementsByTagName('mosaic-text-input')
    for (const j of textElements) {
      if (j.name && j.name.includes('label')) {
        j.addEventListener('change', (e) => {
          this.UpdateData(e, 1)
        })
      }
      if (j.name && j.name.includes('importPart')) {
        j.addEventListener('change', (e) => {
          this.updateImport(e, e.target.name)
        })
      }
    }
  }

  updateImportToggle = (e, index) => {
    const importParts = [...this.state.importParts]
    importParts[index].active = e.target.value
    this.setState({ importParts }, this.setup())
  }

  updateImport = (e, index) => {
    const getIndex = index.slice(-1)
    const importParts = [...this.state.importParts]
    if (e.target.name.includes('importPart')) {
      importParts[getIndex].importPart = e.detail.value
    } else {
      importParts[getIndex].type = e.detail.value
    }
    this.setState({ importParts }, () => {
      this.handleSelects()
    })
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      if (e.target.name === 'numberImportParts') {
        this.updateImportParts(parseInt(this.state.numberImportParts))
      }
    })
  }

  textInputBindings = () => {
    this.companyNameRef.current.addEventListener('change', (e) => this.handleChange(e))
    this.importCompanyRef.current.addEventListener('change', (e) => this.handleChange(e))
  }

  handleCompanyActiveChange = (e) => {
    this.setState({ [e.target.name]: e.target.checked })
    this.statusToggleRef.current.label = e.target.checked ? 'Yes' : 'No'
  }

  GLElementCountChange (e) {
    this.updateGLElements(e)
  }

  updateGLElements (e) {
    let count = null
    const GLElements = [...this.state.GLElements]
    if (e.target.value > this.state.GLElements.length) {
      count = e.target.value - GLElements.length
      for (let i = 0; i < count; i++) {
        GLElements.push({
          glNumber: GLElements.length + 1,
          label: '',
          numberCharacters: 1
        })
      }
    } else {
      GLElements.splice(e.target.value)
    }
    this.setState({
      [e.target.name]: e.target.value,
      GLElements
    }, () => {
      this.props.companyModalRef.current.update()
      this.setup()
    })
  }

  updateImportType = (e, index) => {
    const importParts = [...this.state.importParts]
    importParts[index].type = e.target.value
    this.setState({ importParts })
  }

  companyActiveToggle = () => {
    this.statusToggleRef.current.checked = this.state.isCompanyActive
    this.statusToggleRef.current.addEventListener('change', (e) => this.handleCompanyActiveChange(e))
  }

  render () {
    return (
      <mosaic-form-dialog
        id='company-modal-dialog'
        ref={this.props.companyModalRef}
        header-title = {this.props.header}
        confirm-text = 'Confirm changes'
        dismiss-text = 'Cancel'
        size='lg'
      >
        <div className='mb-2'>
          <mosaic-text-input
            label='Name'
            name='name'
            id='company-name'
            value={this.state.name}
            ref={this.companyNameRef}
            required
            pattern='[ A-Za-z0-9.,@()_-]+'
          />
          <div className='small pt-1 s-block text-muted'>Name can only contain A-Z a-z 0-9 _ - () @. , characters</div>
        </div>
        <div className='mb-2'>
          <mosaic-text-input
            label='Import company'
            name='sourceReference'
            id='source-reference'
            ref={this.importCompanyRef}
            value={this.state.sourceReference}
            pattern='[ A-Za-z0-9.,@()_-]+'
            required
          />
          <div className='small pt-1 s-block text-muted'>
               The value must be unique and match the value exported from the FMS application in the company field.
                And this field can only contain A-Z a-z 0-9 _ - () @. , characters
          </div>
        </div>
        <div className='form-group'>
          <p className='font-weight-bold mb-1'>Is your company active?</p>
          <mosaic-toggle
            color='success'
            ref={this.statusToggleRef}
            label={`${this.state.isCompanyActive ? 'Yes' : 'No'}`}
            id='isActive'
            name='isCompanyActive'
            value={this.state.isCompanyActive}
          />
        </div>
        <mosaic-row class='mb-2'>
          <mosaic-col sm='3'>
            <mosaic-select-input
              label='Number of import parts'
              name='numberImportParts'
              value={this.state.numberImportParts}
              errorMessage='Please select a number'
              ref={this.importCountChangeRef}
              no-deselect
            >
              <option value='1' selected></option>
              {_.range(1, 11).map(value => <option key={value} value={value}>{value}</option>)}
            </mosaic-select-input>
          </mosaic-col>
        </mosaic-row>
        <mosaic-row>
          <mosaic-col md='5' lg='5'>
              Import part identifier
          </mosaic-col>
          <mosaic-col md='5' lg='5'>
              Import type
          </mosaic-col>
          <mosaic-col md='2' lg='2'>
              Active
          </mosaic-col>
        </mosaic-row>
        <FormGroup>
          {this.state.importParts &&
                        this.state.importParts.map((data, index) => (
                          <React.Fragment key={index}>
                            <mosaic-row class='mt-3 mb-2'>
                              <mosaic-col md='5' lg='5'>
                                <mosaic-text-input
                                  name={'importPart ' + index}
                                  value={data.importPart}
                                  id='importPartElement'
                                  label=''
                                  ref={this.importPartRef}
                                  pattern='[ A-Za-z0-9.,@()_-]+'
                                  required
                                />
                                <div className='small s-block text-muted'>Import part identifier can only contain A-Z a-z 0-9 _ - () @. , characters</div>
                              </mosaic-col>
                              <mosaic-col md='5' lg='5'>
                                <Input
                                  type='select'
                                  required
                                  name={'selectType' + index}
                                  value={data.type}
                                  no-deselect
                                  onChange={(e) => this.updateImportType(e, index)}
                                  errorMessage='Please select an import type'>
                                  <option value='basic'>9 Box summary</option>
                                  <option value='transaction'>Transactions</option>
                                </Input>
                              </mosaic-col>
                              <mosaic-col md='2' lg='2'>
                                <div style={{ marginTop: '20px' }} >
                                  <PrettySwitch
                                    inline
                                    name='active'
                                    value={data.active}
                                    checked={data.active}
                                    changeHandler={e => this.handleActiveImportChange(e, index)} />
                                </div>
                              </mosaic-col>
                            </mosaic-row>
                          </React.Fragment>
                        ))
          }
        </FormGroup>
        <mosaic-row>
          <mosaic-col>
            <mosaic-alert color='info' compact>
              <p>If you are importing your VAT return from Exchequer, please ensure you select the
                <strong> 9 box summary</strong> option as the import type. You will not be able to export transactional data from Exchequer.</p>
            </mosaic-alert>
          </mosaic-col>
        </mosaic-row>
        <mosaic-row>
          <mosaic-col class='col-md-4'>
            <mosaic-select-input
              block
              label='Number of GL elements'
              errorMessage='Please select a Tax registration.'
              name='numberGLElements'
              id='numberGLElements'
              no-deselect
              value={this.state.numberGLElements}
              ref={this.parentDropdown}>
              <option value=''>Please select</option>
              {_.range(1, 11).map(value => <option key={value} value={value}>{value}</option>)}
            </mosaic-select-input>
          </mosaic-col>
        </mosaic-row>
        <FormGroup>
          {
            this.state.numberGLElements > 0 &&
                <div>
                  <mosaic-row>
                    <mosaic-col>
                      <strong>GL element</strong>
                    </mosaic-col>
                    <mosaic-col>
                      <strong>Characters</strong>
                    </mosaic-col>
                  </mosaic-row>
                  {this.state.GLElements &&
                  this.state.GLElements.map((data, index) => (
                    <mosaic-row key={index}>
                      <mosaic-col class='mt-2'>
                        <mosaic-text-input
                          name={'label' + data.glNumber}
                          value={data.label}
                          label=''
                          required
                          maxLength='25'
                        ></mosaic-text-input>
                      </mosaic-col>
                      <mosaic-col class='mt-2'>
                        <mosaic-select-input
                          label=''
                          no-deselect
                          errorMessage='Please select a number of characters'
                          name={'numberOfCharacters' + data.glNumber}
                          value={data.numberCharacters}>
                          {_.range(1, 31).map(value => <option key={value} value={value} selected={this.state.GLElements[index].numberCharacters === value}>{value}</option>)}
                        </mosaic-select-input>
                      </mosaic-col>
                    </mosaic-row>
                  ))
                  }
                </div>
          }
        </FormGroup>
      </mosaic-form-dialog>
    )
  }
}

CompanyModal.propTypes = {
  companyModalRef: PropTypes.any,
  cancelFunction: PropTypes.func,
  glElements: PropTypes.any,
  hasJournal: PropTypes.bool,
  header: PropTypes.string,
  ImportParts: PropTypes.any,
  Action: PropTypes.string,
  isOpen: PropTypes.bool,
  index: PropTypes.number,
  isCompanyActive: PropTypes.bool,
  name: PropTypes.string,
  numberGLElements: PropTypes.number,
  numberImportParts: PropTypes.number,
  sessionStore: PropTypes.instanceOf(SessionStore),
  saveFunction: PropTypes.func,
  sourceReference: PropTypes.string,
  toggle: PropTypes.func
}

export { CompanyModal }
